import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appActionsContent]',
  standalone: true,
})
export class ActionContentDirective {
  readonly templateRef = inject(TemplateRef<unknown>);
}
